import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DefaultPageInfo } from 'src/constants';
import { InputErrorType } from 'src/helpers';
import {LoginHistory, HistoryData, PageInfoModel, UserMFAMethodModel, UserModel} from 'src/models';
import type { RootState } from '../../../redux/store';
import {
  Auth0UserManagementFilterModel,
  Auth0UserManagementState
} from './types';

const initialState: Auth0UserManagementState = {
  users: [],
  userMFAMethods: [],
  isEditingUserDetails: false,
  userDetailInputErrors: {},
  filter: {},
  filterInputErrors: {},
  selectedUserDetails: undefined,
  initialSelectedUserDetails: undefined,
  pageInfo: DefaultPageInfo,
  loginHistory: undefined,
  historyPageInfo: DefaultPageInfo,
};

export const auth0UserManagementSlice = createSlice({
  name: 'auth0UserManagement',
  initialState,
  reducers: {
    setUsers(state, action: PayloadAction<UserModel[]>) {
      state.users = [...action.payload];
    },
    setUserMFAMethods(state, action: PayloadAction<UserMFAMethodModel[]>) {
      state.userMFAMethods = [...action.payload];
    },
    setIsEditingUserDetails(state, action: PayloadAction<boolean>) {
      state.isEditingUserDetails = action.payload;
    },
    setUserDetailInputErrors(
      state,
      action: PayloadAction<InputErrorType<UserModel>>
    ) {
      state.userDetailInputErrors = action.payload;
    },
    setFilter(state, action: PayloadAction<Auth0UserManagementFilterModel>) {
      state.filter = { ...action.payload };
    },
    setFilterInputErrors(
      state,
      action: PayloadAction<InputErrorType<Auth0UserManagementFilterModel>>
    ) {
      state.filterInputErrors = action.payload;
    },
    setSelectedUserDetails(state, action: PayloadAction<UserModel>) {
      state.selectedUserDetails = { ...action.payload };
    },
    setInitialSelectedUserDetails(state, action: PayloadAction<UserModel>) {
      state.initialSelectedUserDetails = { ...action.payload };
    },
    setPageInfo(state, action: PayloadAction<PageInfoModel>) {
      state.pageInfo = { ...action.payload };
    },
    setDeleteStatus(state, action: PayloadAction<boolean>) {
      state.deleteStatus = action.payload;
    },
    setLoginHistory(state, action: PayloadAction<HistoryData[]>) {
      state.loginHistory = action.payload;
    },
    setHistoryPageInfo(state, action: PayloadAction<PageInfoModel>) {
      state.historyPageInfo = { ...action.payload };
    }
  }
});

export const {
  setUsers,
  setUserMFAMethods,
  setIsEditingUserDetails,
  setUserDetailInputErrors,
  setFilter,
  setSelectedUserDetails,
  setInitialSelectedUserDetails,
  setPageInfo,
  setFilterInputErrors,
  setDeleteStatus,
  setLoginHistory,
  setHistoryPageInfo
} = auth0UserManagementSlice.actions;

export const auth0UserManagementState = (state: RootState) =>
  state.auth0UserManagement;

export const auth0UserManagementReducer = auth0UserManagementSlice.reducer;
